import PropTypes from 'prop-types';
import css from 'styled-jsx/css';
import classnames from 'classnames';
import { colors } from '../Theme';

const styles = css`
  .icon-button {
    border: none;
    border-radius: 50%;
    background-color: ${colors.ywgVeryLightBlue};
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon-button_icon {
    height: 50%;
    min-width: 50%;
  }
  .icon-button--s {
    width: 24px;
    height: 24px;
  }
  .icon-button--m {
    min-width: 50px;
    height: 50px;
  }
`;
const IconButton = ({ className, icon, size, alt, ...props }) => {
  return (
    <button
      className={classnames(className, 'icon-button', {
        'icon-button--s': size === 's',
        'icon-button--m': size === 'm'
      })}
      {...props}
    >
      <img
        className="icon-button_icon"
        src={`/static/images/icons/${icon}.svg`}
        alt={alt}
      ></img>
      <style jsx>{styles}</style>
    </button>
  );
};
IconButton.propTypes = {
  icon: PropTypes.oneOf(['trash', 'edit']).isRequired,
  alt: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['s', 'm']),
  className: PropTypes.string
};

IconButton.defaultProps = {
  size: 's'
};

export default IconButton;
